import { useApiQuery } from '@tasama/api-client-query';
import type { CatalogItemSchema } from '@tasama/types';
import { CATALOG_ITEMS_ENDPOINTS } from '../types/catalog-item.types';

export const useCatalogItemSchemaQuery = (catalogItemSysId: string) => {
  const { data, isPending, error } = useApiQuery<CatalogItemSchema>(
    ['catalog-item-schema', catalogItemSysId],
    CATALOG_ITEMS_ENDPOINTS.SCHEMA(catalogItemSysId),
    {
      enabled: !!catalogItemSysId,
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    }
  );

  return {
    schema: data ?? null,
    loading: isPending && !!catalogItemSysId,
    error: error?.message ?? null,
  };
};
